import React from "react";

export const emailValidate = (email) => {
  //  let emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var pattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );
  if (!pattern.test(email)) {
    return false;
  }
  return true;

  //if( emailRegexp.test(String(email).toLowerCase()) ) return true //email ok

  //return false
};

export const breakLine = (text) => {
  if (typeof text === "number") {
    return text;
  } else if (typeof text !== "string") {
    return "";
  }

  var regex = /(\r\n|\r|\n)/g;
  return text.split(regex).map(function (line, index) {
    return line.match(regex) ? <br key={"key_" + index} /> : line;
  });
  /*
  var regex = /(<br( |)\/>)/g;
  return text.split(regex).map(function(line, index) {
      return line.match(regex) ? <br key={"key_" + index} /> : line;
  });
  */
};

export const sortArticle = (articleA, articleB) => {
  if (articleA.order === undefined || articleB.order === undefined) return 0;
  if (articleA.order === articleB.order) return 0;

  return articleA.order > articleB.order ? 1 : -1;
};



// WEBPACK FOOTER //
// ./src/utils/index.js